<div class="headshot-container">
  <div
    class="headshot-placeholder-container"
    *ngIf="!imageUrl || pictureLoadError">
    <div class="headshot-placeholder">
      <i class="fa-thin fa-circle-user"></i>
    </div>
  </div>
  <div class="headshot-image" *ngIf="imageUrl && !pictureLoadError">
    <img
      [src]="imageUrl"
      [alt]="'profile_picture' | translation: 'Profile picture'"
      class="profile-image"
      (error)="pictureLoadError = true" />
  </div>
</div>
